import { useState, useEffect } from 'react';
import { useQuery, useAction } from 'convex/react';
import { api } from '../../api';
import { useUserDevice } from './useUserDevice';

export interface InstalledApp {
  trackId: string;
  version?: string;
}

export const useInstalledApps = () => {
  const { device, jssid } = useUserDevice();
  const [installedApps, setInstalledApps] = useState<InstalledApp[] | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Use the updates action to get installed apps
  const updatesAction = useAction(api.apps.list.updates);

  useEffect(() => {
    const loadInstalledApps = async () => {
      if (!jssid) {
        setIsLoading(false);
        setInstalledApps([]);
        return;
      }

      try {
        setIsLoading(true);
        setError(null);
        
        console.log('Loading installed apps for jssid:', jssid);
        const result = await updatesAction({ serial: jssid as any });
        console.log('Device library result:', result);
        
        setInstalledApps(result);
      } catch (err) {
        console.error('Error loading installed apps:', err);
        setError(err instanceof Error ? err.message : 'Failed to load installed apps');
        setInstalledApps([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadInstalledApps();
  }, [jssid, updatesAction]);

  return {
    installedApps,
    isLoading,
    error,
    device,
    jssid
  };
};